import { markRaw } from 'vue';
import mapIcon from '@/assets/bxs-map-alt.svg';
import ghostIcon from '@/assets/bxs-ghost.svg';
import infoIcon from '@/assets/bxs-info-circle.svg';
import UserProfileCard from '@/components/user/UserProfileCard.vue';

const userProfileCard = markRaw(UserProfileCard);

const developerMenu = [
  {
    href: '/',
    component: userProfileCard,
    hiddenOnCollapse: true,
  },
  {
    title: '',
    titleKey: 'projectManagement',
    icon: {
      element: 'img',
      attributes: { src: mapIcon },
    },
    child: [
      {
        href: '/project',
        title: '',
        titleKey: 'listProject',
      },
    ],
  },
  {
    title: '',
    titleKey: 'deviceManagement',
    icon: {
      element: 'img',
      attributes: { src: ghostIcon },
    },
    child: [
      {
        href: '/device',
        title: '',
        titleKey: 'listDevice',
      },
    ],
  },
  {
    title: '',
    titleKey: 'dataManagement',
    icon: {
      element: 'img',
      attributes: { src: infoIcon },
    },
    child: [
      {
        href: '/history',
        title: '',
        titleKey: 'listHistory',
      },
    ],
  },
];

export default developerMenu;
